export class ConnectionError extends Error {}
